export enum UserRoles {
    ADMIN = 'admin',
    CUSTOMER_SERVICE = 'customer_service',
    ACCOUNTS_TEAM = 'accounts_team',
    OPERATIONS_TEAM = 'operations_team',
    DRIVER_MANAGER = 'driver_manager',
    GUEST = 'guest'
}